#import "./variantWithProductFragment.gql"

fragment cartFragment on Cart {
  id
  buyerIdentity {
    countryCode
  }
  checkoutUrl
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
    totalTaxAmount {
      amount
      currencyCode
    }
  }
  lines(first: 100) {
    nodes {
      id
      quantity
      variant: merchandise {
        ...variantWithProductFragment
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
      }
      discountAllocations {
        discountedAmount {
          amount
          currencyCode
        }
      }
      attributes {
        key
        value
      }
    }
  }
  totalQuantity
  discountCodes {
    applicable
    code
  }
  discountAllocations {
    discountedAmount {
      amount
      currencyCode
    }
  }
  attributes {
    key
    value
  }
}
